/**
 * Affiche le metafield produit JSON `custom.specs` (objet clé → valeur).
 */
(function () {
  var VISIBLE_ROWS_LIMIT = 10;
  var TOGGLE_ICON_SVG =
    '<svg class="massin-product-specs__toggle-icon" aria-hidden="true" focusable="false" width="12" height="8" viewBox="0 0 12 8" fill="none">' +
    '<path d="M1 1.5 6 6.5 11 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
    "</svg>";

  function normalizeSpecsData(raw) {
    var data = raw;

    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (error) {
        return null;
      }
    }

    if (Array.isArray(data)) {
      if (data.length === 1) {
        return normalizeSpecsData(data[0]);
      }
      return null;
    }

    if (
      data &&
      typeof data === "object" &&
      data.specs &&
      typeof data.specs === "object"
    ) {
      data = data.specs;
    }

    if (!data || typeof data !== "object" || Array.isArray(data)) {
      return null;
    }

    return data;
  }

  function renderSection(section) {
    if (section.dataset.massinSpecsReady === "1") return;

    var source = section.querySelector("[data-massin-specs-source]");
    var list = section.querySelector("[data-massin-specs-list]");
    if (!source || !list) return;

    var raw;
    try {
      raw = JSON.parse(source.textContent);
    } catch (error) {
      return;
    }

    var data = normalizeSpecsData(raw);
    if (!data) return;

    var keys = Object.keys(data).filter(function (key) {
      var value = data[key];
      return value != null && value !== "";
    });
    if (!keys.length) return;

    var fragment = document.createDocumentFragment();
    var isFullWidth = section.classList.contains("massin-product-specs--full-width");

    function createRow(key, index) {
      var value = data[key];

      if (typeof value === "object") {
        value = JSON.stringify(value);
      }

      var row = document.createElement("div");
      row.className = "massin-product-specs__row";
      if (index % 2 === 0) {
        row.classList.add("massin-product-specs__row--striped");
      }

      var label = document.createElement("dt");
      label.className = "massin-product-specs__label";
      label.textContent = key;

      var val = document.createElement("dd");
      val.className = "massin-product-specs__value";
      val.textContent = String(value);

      row.appendChild(label);
      row.appendChild(val);
      return row;
    }

    if (isFullWidth && keys.length > 1) {
      var midpoint = Math.ceil(keys.length / 2);
      var leftCol = document.createElement("div");
      leftCol.className = "massin-product-specs__column massin-product-specs__column--left";
      var rightCol = document.createElement("div");
      rightCol.className = "massin-product-specs__column massin-product-specs__column--right";
      var rowCount = midpoint;

      keys.slice(0, midpoint).forEach(function (key, i) {
        leftCol.appendChild(createRow(key, i));
      });
      keys.slice(midpoint).forEach(function (key, i) {
        rightCol.appendChild(createRow(key, i));
      });

      list.style.setProperty("--massin-specs-rows", String(rowCount));
      fragment.appendChild(leftCol);
      fragment.appendChild(rightCol);
    } else {
      keys.forEach(function (key, i) {
        var row = createRow(key, i);
        if (i >= VISIBLE_ROWS_LIMIT) {
          row.classList.add("massin-product-specs__row--extra");
          row.hidden = true;
        }
        fragment.appendChild(row);
      });
    }

    if (!fragment.childNodes.length) return;

    list.replaceChildren(fragment);
    setupToggle(section, list);
    section.hidden = false;
    section.dataset.massinSpecsReady = "1";
  }

  function setupToggle(section, list) {
    var existingToggle = section.querySelector(".massin-product-specs__toggle");
    if (existingToggle) existingToggle.remove();

    var extraRows = list.querySelectorAll(".massin-product-specs__row--extra");
    if (!extraRows.length) {
      section.classList.remove("massin-product-specs--collapsed");
      return;
    }

    section.classList.add("massin-product-specs--collapsed");

    var collapsedLabel = "Voir plus (" + extraRows.length + ")";
    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "massin-product-specs__toggle";
    toggle.setAttribute("aria-expanded", "false");
    if (list.id) toggle.setAttribute("aria-controls", list.id);

    var label = document.createElement("span");
    label.className = "massin-product-specs__toggle-label";
    label.textContent = collapsedLabel;
    toggle.appendChild(label);
    toggle.insertAdjacentHTML("beforeend", TOGGLE_ICON_SVG);

    toggle.addEventListener("click", function () {
      var expand = toggle.getAttribute("aria-expanded") !== "true";
      toggle.setAttribute("aria-expanded", String(expand));
      extraRows.forEach(function (row) {
        row.hidden = !expand;
      });
      section.classList.toggle("massin-product-specs--collapsed", !expand);
      label.textContent = expand ? "Voir moins" : collapsedLabel;

      if (!expand) {
        var behavior = window.matchMedia("(prefers-reduced-motion: reduce)")
          .matches
          ? "auto"
          : "smooth";
        section.scrollIntoView({ block: "nearest", behavior: behavior });
      }
    });

    list.insertAdjacentElement("afterend", toggle);
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-massin-product-specs]").forEach(renderSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
